const doc = [({"da":({"js":({"admin":({"communication":({"templates":({"templates":"Skabeloner"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;